import { getLegacyTimelineDetails } from '@api';
import { createGetAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const coreLegacyTimelineDetailsGetAsyncSlice = createGetAsyncSlice({
	name: 'CoreLegacyTimelineDetails',
	receive: true,
	request: true,
	requestHandler: getLegacyTimelineDetails,
	retainDataOnRequest: true,
	yieldType: SagaYieldType.Latest
});
